<span class="fa fa-exclamation-triangle"></span>
<p class="warning">{{ warning }}</p>
